import { JSXElement, mergeProps } from 'solid-js';
import AdminPortalErrorBoundary from '~/components/ErrorBoundaries/AdminPortalErrorBoundary.tsx';

type CustomerPortalSSOBaseProps = {
  children: JSXElement;
};

export default function AdminPortalBase(
  props: CustomerPortalSSOBaseProps
): JSXElement {
  const merged = mergeProps({}, props);

  return (
    <AdminPortalErrorBoundary>
      <div class={`w-full min-h-screen bg-bg-disabled`}>{merged.children}</div>
    </AdminPortalErrorBoundary>
  );
}
